<div>
    <div class=" dcp-custom-form dcp p-2">
        <div class="d-flex align-items-center justify-content-between mb-3 pb-2">
            <h2 class="mb-0">No action has been taken on following patient:</h2>
            <div class="btn-light btn-position"> <span class="mat-icon material-icons"
                    (click)="closeModal()">close</span>
            </div>
        </div>
    </div>

    <div class="dcp">
        <table class="table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Full Name</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let patient of data.patients; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ patient.userInfo.fullName }}</td>
                </tr>
            </tbody>
        </table>
        <div class="d-flex justify-content-end gap-2">
            <button class="btn btn-outline-primary" (click)="closeModal('false')">Cancel</button>
            <button class="btn btn-primary" (click)="closeModal('true')">Continue</button>
        </div>
    </div>
</div>